<template>
  <div style="display: flex">
    <div
      v-for="(day, index) in days"
      v-if="
        typeof error_per_date[day.format_month_day] === 'object' &&
        Object.keys(error_per_date[day.format_month_day]).length > 0
      "
      :key="index"
    >
      <Exclamation-Triangle
        :filterd_days_hope_holiday_error="error_per_date"
        active_dialog="hope_holiday"
      />
    </div>
    <div
      v-else="
        typeof error_per_date[day.format_month_day] === 'object' &&
        Object.keys(error_per_date[day.format_month_day]).length === 0
      "
      style="margin-left: 42px"
    >
      <!-- 調整のための空DIV -->
    </div>
  </div>
</template>

<style scoped></style>

<script>
import ExclamationTriangle from '@/Pages/Components/Svg/ExclamationTriangle.vue';

export default {
  name: 'AlertHopeHoliday',
  components: {
    ExclamationTriangle,
  },
  props: {
    staff_assignments: {
      type: Object,
      default: () => {
        return {};
      },
    },
    new_shifts: {
      type: Object,
      default: function () {
        return {};
      },
    },
    days: { type: Array },
    basic_infos: { type: Array },
    team_id: { type: Number },
    change_total_members_count: { type: Number },
  },
  data() {
    return {
      total_min_for_day_sorted: {}, //常時配置人数の下限値の合計
      min_max_per_category_and_workpattern: {}, //ワークパターン、カテゴリごとの常時配置人数下限値と上限値
      hope_holiday_count_per_date: {}, //希望休の日ごとの数
      error_per_date: {}, //日ごとに複数のエラーをまとめる
      count_staff_each_day_by_workpattern: {}, //ワークパターンごとの職員数
    };
  },
  methods: {
    // 常時配置人数のminの合計
    minCountListForDay() {
      // 勤務区分合計のmin
      let total_min_for_day = {};
      let min_max_per_category_and_workpattern = {};
      Object.keys(this.staff_assignments).map((workpattern_id) => {
        if (!min_max_per_category_and_workpattern[workpattern_id]) {
          min_max_per_category_and_workpattern[workpattern_id] = {};
        }

        // dayごと（縦列）の合計
        Object.keys(this.staff_assignments[workpattern_id]).map((day) => {
          // dayがdefなら飛ばす
          if (day === 'def') return;
          // 初期化
          if (total_min_for_day[day] === undefined) {
            total_min_for_day[day] = 0;
          }
          if (!min_max_per_category_and_workpattern[workpattern_id][day]) {
            min_max_per_category_and_workpattern[workpattern_id][day] = 0;
          }
          let min_count =
            Number(this.staff_assignments[workpattern_id][day].min) ||
            Number(this.staff_assignments[workpattern_id]['def'].min);
          let max_count =
            Number(this.staff_assignments[workpattern_id][day].max) ||
            Number(this.staff_assignments[workpattern_id]['def'].max);

          total_min_for_day[day] += min_count;
          min_max_per_category_and_workpattern[workpattern_id][day] = {
            min: min_count,
            max: max_count,
          };
        });
      });

      // mon,tue,wed,thu,fri,sat,sun,holの順に並び替え
      const day_of_weeks = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun', 'hol'];
      const total_min_for_day_sorted = {};
      day_of_weeks.forEach((day) => {
        total_min_for_day_sorted[day] = total_min_for_day[day];
      });

      this.total_min_for_day_sorted = total_min_for_day_sorted;
      this.min_max_per_category_and_workpattern = min_max_per_category_and_workpattern;
    },
    //日ごと、ワークパターンごとの配置職員数
    countStaffPerDateByWorkpattern() {
      let count_staff_each_day_by_workpattern = {};

      let already_count_workpattern = {}; //同一日の同一オフィススタッフで既にカウント済みのworkpatternは除外したい
      Object.entries(this.new_shifts).forEach(([office_staff_occupation_id, values]) => {
        Object.entries(values).forEach(([date, shifts]) => {
          //初期化
          if (!count_staff_each_day_by_workpattern[date]) {
            count_staff_each_day_by_workpattern[date] = {};
          }
          if (!already_count_workpattern[date]) {
            already_count_workpattern[date] = {};
          }

          if ('shift' in shifts) {
            let workpattern_id = shifts.shift.workpattern_id;
            let office_staff_id = shifts.shift.office_staff_id;

            //初期化
            if (!count_staff_each_day_by_workpattern[date][workpattern_id]) {
              count_staff_each_day_by_workpattern[date][workpattern_id] = 0;
            }
            if (!already_count_workpattern[date][office_staff_id]) {
              already_count_workpattern[date][office_staff_id] = {};
            }

            //既にカウントしていれば処理をスルー
            if (already_count_workpattern[date][office_staff_id][workpattern_id]) {
              return;
            }

            //カウントアップ
            count_staff_each_day_by_workpattern[date][workpattern_id] += 1;
            // 同一日のoffice_staff、workpatternをカウントアップ済みにする
            already_count_workpattern[date][office_staff_id][workpattern_id] = true;
          }
        });
      });
      this.count_staff_each_day_by_workpattern = count_staff_each_day_by_workpattern;
    },
    //日ごとの希望休、希望勤務を集計する処理
    calculateHopeHolidayCountPerDay() {
      let office_staff_holdiday_flg_per_date = {}; //office_staffの休日判定を日ごとにまとめたもの
      this.basic_infos.forEach((basic_info) => {
        let office_staff_id_occupation_id =
          basic_info.office_staff_id + '_' + basic_info.occupation_id;
        let new_shift = this.new_shifts[office_staff_id_occupation_id];

        if (!new_shift) {
          return;
        }
        if (!office_staff_holdiday_flg_per_date[basic_info.office_staff_id]) {
          office_staff_holdiday_flg_per_date[basic_info.office_staff_id] = {};
        }

        Object.entries(new_shift).forEach(([date, values]) => {
          //初期化
          if (!office_staff_holdiday_flg_per_date[basic_info.office_staff_id][date]) {
            office_staff_holdiday_flg_per_date[basic_info.office_staff_id][date] = true;
          }
          //shiftが設定されていない、同一office_staffでworkpatternがholiday以外がみつかった、workpatternがnullの場合
          if (
            !('shift' in values) ||
            (values['shift'].workpattern && values['shift'].workpattern.category != 'holiday') ||
            values['shift'].workpattern === null
          ) {
            office_staff_holdiday_flg_per_date[basic_info.office_staff_id][date] = false;
          }
        });
      });

      //日ごとの休日数を全オフィススタッフカウント
      let hope_holiday_count_per_date = {};
      Object.values(office_staff_holdiday_flg_per_date).forEach((values) => {
        Object.entries(values).forEach(([date, holiday_flg]) => {
          //初期化
          if (!hope_holiday_count_per_date[date]) {
            hope_holiday_count_per_date[date] = { holiday: 0 };
          }

          if (holiday_flg) {
            hope_holiday_count_per_date[date].holiday += 1;
          }
        });
      });
      this.hope_holiday_count_per_date = hope_holiday_count_per_date;
    },

    alertHopeHoliday() {
      // 常時配置人数の下限値の集計
      this.minCountListForDay();

      // 日ごとの希望休の数
      this.calculateHopeHolidayCountPerDay();

      //日ごとワークパターンごとの配置職員数
      this.countStaffPerDateByWorkpattern();

      //エラーロジックの実行
      this.calcAlert();
    },
    //エラーロジックの実行
    calcAlert() {
      const error_hope_holiday = this.errorHopeHoliday();
      const error_setting_and_staff_count = this.errorSettingAndStaffCount();
      let errors = {};
      this.days.forEach((day, index) => {
        let format_month_day = day['format_month_day'];
        errors[format_month_day] ||= {};

        if (Object.keys(error_hope_holiday[day['full']]).length > 0) {
          errors[format_month_day]['hope_holiday'] = error_hope_holiday[day['full']];
        }
        if (Object.keys(error_setting_and_staff_count[day['full']]).length > 0) {
          errors[format_month_day]['setting_and_staff_count'] =
            error_setting_and_staff_count[day['full']];
        }
      });

      this.error_per_date = errors;
    },
    //日ごとの勤務区分の下限値 < 日ごとの勤務区分の配置職員数
    errorSettingAndStaffCount() {
      const differenceCountSettingAndStaff = (day_full, workpattern_id, week_short_name) => {
        if (!this.min_max_per_category_and_workpattern[workpattern_id]) {
          return 0;
        }

        const actual_staff_count =
          this.count_staff_each_day_by_workpattern[day_full][workpattern_id] || 0;
        const setting_total_min =
          this.min_max_per_category_and_workpattern[workpattern_id][week_short_name]?.min || 0;

        return setting_total_min - actual_staff_count;
      };

      let errors = {};
      this.days.forEach((day, index) => {
        errors[day['full']] ||= {};

        this.basic_infos.forEach((basic_info, key) => {
          let office_staff_id_occupation_id =
            basic_info.office_staff_id + '_' + basic_info.occupation_id;
          let new_shift = this.new_shifts[office_staff_id_occupation_id];

          if (new_shift?.[day['full']] && 'shift' in new_shift[day['full']]) {
            let workpattern = new_shift[day['full']]['shift']['workpattern'];
            if (!workpattern) {
              return;
            }

            let week_short_name = day.holiday ? 'hol' : day.week_short_name;

            let difference_count = differenceCountSettingAndStaff(
              day['full'],
              workpattern.id,
              week_short_name
            );
            if (difference_count > 0) {
              let total_max_min_setting =
                this.min_max_per_category_and_workpattern[workpattern.id][week_short_name];
              errors[day['full']][workpattern.id] = {
                workpattern_name: workpattern.name,
                difference_count: difference_count,
                total_max_min_setting: total_max_min_setting,
              };
            }
          }
        });
      });
      return errors;
    },

    errorHopeHoliday() {
      //職員数-常時配置人数の下限値の合計 < 希望休の数
      const isHopeHolidayError = (day_full, week_short_name) => {
        if (
          day_full in this.hope_holiday_count_per_date &&
          this.change_total_members_count - this.total_min_for_day_sorted[week_short_name] <
            this.hope_holiday_count_per_date[day_full].holiday
        ) {
          return true;
        }

        return false;
      };
      let errors = {};
      this.days.forEach((day, index) => {
        errors[day['full']] ||= {};

        if (isHopeHolidayError(day['full'], day.week_short_name)) {
          errors[day['full']] = { error: true };
        }
      });
      return errors;
    },
  },
  created() {
    this.$nextTick(() => {
      this.alertHopeHoliday();
    });
  },
  mounted() {},
};
</script>
